import { useGetApiV1PersonIdAttachmentsDocumentRejectionReasons } from '@/shared/api/generated';

export interface RejectionReasonOption {
  readonly id: number;
  readonly name: string;
}

/**
 * Hook para listar os motivos de rejeição de documentos.
 *
 * @param personId - ID da pessoa
 * @returns Lista mapeada de motivos e estado de loading
 *
 * @example
 * ```tsx
 * const { options } = useRejectionReasons(personId);
 * ```
 */
export function useRejectionReasons(personId: number) {
  const query = useGetApiV1PersonIdAttachmentsDocumentRejectionReasons(personId);

  const options: readonly RejectionReasonOption[] = (query.data ?? []).map(item => ({
    id: item.key ?? 0,
    name: item.value ?? '',
  }));

  return {
    options,
    isLoading: query.isLoading,
  } as const;
}
